<his-search-form
    #searchForm
    configFile="{{SEARCH_CONFIG_PUBLICATION_ORCID_USER}}"
    [isSearchFormResult]="true"
    [isNestedSearchForm]="true"
    (onSubmitSearch)="onSubmitSearch($event)"
    [searchShowSearchParamsBox]="false">
</his-search-form>

